module.exports = __webpack_public_path__ + "static/smh-logo-50b4ab47b62a0d3e3d1f0d44b6dc65d6.png";